export default __webpack_public_path__ + "static/media/bank-disposal.0b07098b.svg";